<form [formGroup]="list" [id]="id">
    @for (item of list.controls; let i = $index; track i) {
        <div class="sh-form-row-with-action" style="margin-bottom: 0px">
            <div class="sh-form-row-with-action__inputs">
                @if (getValueControl(i); as control) {
                    <div class="sh-form-row-with-action__inputs__item" [ngClass]="{ 'sh-form-group -sh-is-invalid': control.invalid }">
                        <ng-container *ngIf="!isNumberField; else numberField">
                            <sh-autocomplete [autocompleteFct]="autocompleteFct">
                                <input
                                    #inputFields
                                    tabindex="0"
                                    type="text"
                                    autocomplete="off"
                                    [formControl]="control"
                                    [id]="getValueId(i)"
                                    [attr.placeholder]="placeholderMsg || null"
                                    class="sh-form-group__input sh-input-field"
                                    [attr.disabled]="disabled ? true : null"
                                    (blur)="sanitizeValue($event, i)"
                                    [title]="disabledMsg"
                                    (keyup.enter)="addEmptyLine($event)"
                                />
                            </sh-autocomplete>
                        </ng-container>
                        <ng-template #numberField>
                            <sh-form-number-input
                                #inputFields
                                [id]="getValueId(i)"
                                [control]="control"
                                [title]="disabledMsg"
                                [attr.step]="step"
                                [attr.min]="min"
                                [attr.max]="max"
                                [placeholder]="placeholderMsg || null"
                                (keyup.enter)="addEmptyLine($event)"
                            >
                            </sh-form-number-input>
                        </ng-template>
                        <p *ngIf="control.invalid && control.errors?.message" class="sh-form-group -sh-is-invalid sh-form-group__feedback">
                            {{ control.errors?.message | translate }}
                        </p>
                    </div>
                }
            </div>
            <div *ngIf="actionItems$ | async as actionItems" class="sh-form-row-with-action__actions">
                <sh-action-item
                    class="sh-form-row-with-action__actions__item"
                    *ngFor="let actionItem of actionItems[i]"
                    [item]="actionItem"
                    [bubbleEvent]="false"
                ></sh-action-item>
            </div>
        </div>
    }
</form>
<p *ngIf="(hasDuplicateInput$ | async) && duplicateErrorMsg" class="sh-form-group__feedback">{{ duplicateErrorMsg }}</p>
<p *ngIf="isIndeterminate && indeterminateMsg" class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
